module.exports = __webpack_public_path__ + "static/media/logo-white.37af6fb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-white.svg
// module id = 348
// module chunks = 1